import { mediaItems } from '@/mocks/homeData';

const mediaImages = [
  'https://readdy.ai/api/search-image?query=dramatic%20warm%20toned%20night%20scene%20with%20soft%20bokeh%2C%20crimson%20and%20amber%20cinematic%20lighting%2C%20abstract%20entertainment%20video%20aesthetic%2C%20editorial%20style%2C%20no%20text&width=800&height=450&seq=media-01-51cg&orientation=landscape',
  'https://readdy.ai/api/search-image?query=dark%20warm%20toned%20live%20stream%20abstract%2C%20crimson%20glow%2C%20soft%20dramatic%20lighting%2C%20editorial%20photography%20style%2C%20no%20text%2C%20mysterious&width=800&height=450&seq=media-02-51cg&orientation=landscape',
  'https://readdy.ai/api/search-image?query=warm%20toned%20backstage%20cinematic%20scene%2C%20dark%20amber%20and%20crimson%2C%20soft%20spotlight%2C%20editorial%20style%2C%20no%20text%2C%20mysterious%20atmosphere&width=800&height=450&seq=media-03-51cg&orientation=landscape',
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full bg-background-100 py-14 md:py-20 px-4 md:px-6 lg:px-10">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-foreground-950 font-heading font-bold text-2xl md:text-3xl lg:text-4xl mb-3">
            独家视频
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            精选独家视频内容，每一帧都是料
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, idx) => (
            <a
              key={idx}
              href="#media"
              className="group relative aspect-video rounded-xl overflow-hidden cursor-pointer block"
            >
              <img
                src={mediaImages[idx]}
                alt={item.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center group-hover:bg-white/30 transition-colors">
                  <i className="ri-play-fill text-white text-2xl md:text-3xl ml-0.5"></i>
                </div>
              </div>
              <div className="absolute bottom-3 left-3 md:bottom-4 md:left-4">
                <h3 className="text-white font-heading font-bold text-sm md:text-base leading-snug mb-1">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3">
                  <span className="inline-flex items-center gap-1 bg-black/40 backdrop-blur-sm text-white px-2 py-0.5 rounded text-xs">
                    <i className="ri-time-line text-xs"></i>
                    {item.duration}
                  </span>
                  <span className="text-white/70 text-xs">{item.views}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}